<template>
    <div class="bg-white px-3" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">
                            新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="name" label="名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="问题模块">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handlelookqu(scope.$index, scope.row)">查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="结果">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handlelookRess(scope.$index, scope.row)">查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip> </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div> -->

        </div>
        <!--  -->
        <el-dialog title="设置" :visible.sync="dialogs" top="150px" width="40%" center class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='editloading'>
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-form-item label="名称" prop="name">
                            <el-input placeholder="请输入内容" size='small' v-model="form.name"> </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading='subloading' @click="submit('form')" size="small">确 定
                            </el-button>
                            <el-button @click="dialogs = false" size="small">取 消</el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>
        <!-- 问题-->
        <el-dialog title="问题设置" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span> -->
        </el-dialog>
        <!-- 答案-->
        <el-dialog title="答案设置" :visible.sync="ressdetail" top="50px" width="60%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <Ress ref="reslist" />
            <el-divider></el-divider>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="ressdetail=false" size="small">确定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Contentvotelist from "./problems.vue";
    import Ress from "./ress.vue";
    export default {
        components: {
            Contentvotelist,
            Ress
        },
        data() {
            return {
                dialog: false,
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                mtheights: {
                    height: null,
                    "overflow": "auto",
                },

                // 
                eid: '',
                props: {
                    label: 'problem',
                    children: 'children'
                },
                dialogs: false,
                form: {
                    name: '',
                    category_id: '',
                    type: 1
                },
                rule: {
                    name: [{
                        required: true,
                        message: '问卷名称不能为空'
                    }],
                    category_id: [{
                        required: true,
                        message: '请选择分类'
                    }],

                },
                contentvotedetail: false,
                editloading: false,

                subloading: false,
                type_options: [
                ],
                category_id: '',
                ressdetail: false,
                textId:''

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
        },
        methods: {
          
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 175 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 175 + 'px'
                }

                
            },
            getlist(id) {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/medicine/category/Mlist", {
                        // page: that.currentPage,
                        // page_count: that.pagesize,
                        pid: id
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data


                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.getlist(this.textId)
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.getlist(this.textId)
            },

            // 新增
            add() {
                let that = this
                that.clear()
                that.dialogs = true
                that.eid = '0'
                
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls;
                         if (this.eid && this.eid != '0') {
                            urls = "/admin/pc/medicine/category/Mupdate"
                        } else {
                            urls = "/admin/pc/medicine/category/Mcreate"
                        }
                        that.subloading = true
                        axios
                            .post(`${urls}`, {
                                id: that.eid,
                                pid: this.textId,
                                name: that.form.name,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.getlist(this.textId)
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                                that.subloading = false
                            })
                            .catch(error => {
                                that.subloading = false

                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.form.name = row.name
                // that.form.category_id = row.pid
                // that.clear()

            },
            handlelookqu(index, row) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            handlelookRess(index, row) {
                this.ressdetail = true
                this.$nextTick(() => {
                    this.$refs.reslist.textId = row.id
                    this.$refs.reslist.getlist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/medicine/category/Mdel", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.getlist(this.textId)
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                that.form.name = ''
                that.form.category_id = ''
            },
        },

    };
</script>


<style scoped>
    .mr_ck {
        margin: 10px 0;
    }

    .f_w {
        font-weight: 600;
    }

    .bds {
        border-bottom: 1px solid #f5f5f5
    }

    .btn {
        margin-left: 20px;
    }
</style>